const baseDomain = `${window.location.protocol}//${window.location.host}`;
const baseUrl = `${baseDomain}/roboroy/api/v2`; // this is the baseurl for API calls only

export { baseUrl };
